import { Component } from "react";
import React from "react";

import { Button } from '@material-ui/core'

import PaperBlock from "../../../ui/PaperBlock.js"

/**
 * Панель выбора сосуда Дьюара.
 * 
 * @param props.selected - выбранный ранее сосуд Дьюара.
 * @param props.onSelectButtonClick
 */

class SelectDewarPanel extends Component {

    render() {
        return <PaperBlock style = {{width: "100%", padding: "0px"}}>
            <div style={{margin: "10px", display: "flex"}}>

                <div style={{flex: "1 1 auto", display: "flex", alignItems: "center"}}>
                    {this.props.selected ? this.props.selected.code : ""}
                </div>
                
                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSelectButtonClick === "function") {
							this.props.onSelectButtonClick()
						}
					}}
				>
					Выбрать сосуд
				</Button>                

            </div>
        </PaperBlock>
    }

}

export default SelectDewarPanel